module.exports = {
    "Clear search": `Cancella ricerca`
};


//# sourceMappingURL=it-IT.main.js.map
